var map = {
	"./en/buttons.json": 1004,
	"./en/dialogs.json": 7367,
	"./en/elements.json": 1558,
	"./en/music.json": 6361,
	"./en/shortcuts.json": 4638,
	"./fr/buttons.json": 252,
	"./fr/dialogs.json": 1364,
	"./fr/elements.json": 9336,
	"./fr/music.json": 9910,
	"./fr/shortcuts.json": 2526,
	"./sl/buttons.json": 7255,
	"./sl/dialogs.json": 529,
	"./sl/elements.json": 6708,
	"./sl/music.json": 4177,
	"./sl/shortcuts.json": 6294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3631;